import * as actions from "./insurance.actions";
import * as api from "./insurance.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY } from "./insurance.constants";
import * as hooks from "./insurance.hooks";
import * as promises from "./insurance.promises";
import reducer from "./insurance.reducer";
import { saga } from "./insurance.saga";
import * as selectors from "./insurance.selectors";
export var REDUCER_KEY_INSURANCE = REDUCER_KEY;
export var insuranceModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: reducer,
    saga: saga,
    selectors: selectors,
    utils: {},
};
